import { cn } from '@/utils/tailwind'

export default function NavigatorIllustration({ className }: { className: string }) {
  return (
    <svg viewBox="0 0 191 173" fill="none" xmlns="http://www.w3.org/2000/svg" className={cn('z-10 w-60', className)}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M129.581 171.24C129.858 169.793 115.977 166.826 98.577 164.612C81.1742 162.397 66.8427 161.777 66.5627 163.223C66.41 164.019 70.5381 165.274 77.1782 166.611C75.1725 166.613 73.9796 166.778 73.9182 167.123C73.7479 168.079 82.3594 170.058 93.1506 171.539C103.944 173.021 112.829 173.445 112.999 172.488C113.055 172.174 112.163 171.75 110.558 171.269C121.583 172.25 129.377 172.304 129.581 171.24Z"
        fill="black"
        fillOpacity="0.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M62.4082 22.2636V140.116C62.4082 146.376 66.5108 151.419 71.8544 152.117L114.66 157.717C114.998 157.761 115.486 157.783 115.486 157.783H119.327C121.619 157.783 123.732 156.745 125.468 154.892C127.458 152.771 128.51 149.987 128.51 146.849V15.9264C128.51 12.7881 127.458 10.0043 125.468 7.88276C123.722 6.01955 121.597 5 119.287 5H115.628C115.308 5 114.985 5.01924 114.658 5.06046L71.8544 10.2626C66.5058 10.9139 62.4082 16.0034 62.4082 22.2636Z"
        fill="#33718F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M62.4082 22.2628V140.116C62.4082 146.376 66.5088 151.419 71.85 152.117L114.636 157.718C117.314 158.067 119.795 157.014 121.784 154.893C123.773 152.774 124.824 149.987 124.824 146.849V15.9256C124.824 12.7873 123.773 10.0034 121.784 7.88188C119.797 5.76308 117.316 4.73254 114.636 5.05956L71.85 10.2618C66.5039 10.9131 62.4082 16.0026 62.4082 22.2628Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64.1289 22.6651V123.321C64.1289 128.667 68.0035 132.974 73.0503 133.57L113.478 138.354C116.008 138.652 118.353 137.753 120.232 135.941C122.111 134.131 123.104 131.751 123.104 129.071L122.858 17.5198C122.858 14.8394 122.111 12.4618 120.232 10.6498C118.355 8.84021 116.011 7.96004 113.478 8.23935L73.0503 12.4153C67.9989 12.9716 64.1289 17.3184 64.1289 22.6651Z"
        fill="#BBDEFB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64.1289 22.6651V123.321C64.1289 128.667 68.0035 132.974 73.0503 133.57L113.478 138.354C116.008 138.652 118.353 137.753 120.232 135.941C122.111 134.131 123.104 131.751 123.104 129.071L122.858 17.5198C122.858 14.8394 122.111 12.4618 120.232 10.6498C118.355 8.84021 116.011 7.96004 113.478 8.23935L73.0503 12.4153C67.9989 12.9716 64.1289 17.3184 64.1289 22.6651Z"
        fill="url(#paint0_linear_8284_55483)"
        fillOpacity="0.13"
      />
      <mask id="mask0_8284_55483" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="63" y="8" width="60" height="131">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M63.6045 22.6651V123.321C63.6045 128.667 67.4791 132.974 72.5259 133.57L112.954 138.354C115.484 138.652 117.828 137.753 119.707 135.941C121.587 134.131 122.58 131.751 122.58 129.071L122.334 17.5198C122.334 14.8394 121.587 12.4618 119.707 10.6498C117.831 8.84021 115.486 7.96004 112.954 8.23935L72.5259 12.4153C67.4745 12.9716 63.6045 17.3184 63.6045 22.6651Z"
          fill="#F4F4F4"
        />
      </mask>
      <g mask="url(#mask0_8284_55483)">
        <path
          d="M90.0205 57.3585C76.7777 24.7908 93.3313 -1.66221 103.263 -10.8178L120.675 -15.9678C112.46 -8.32451 84.5844 7.69772 98.5515 57.3585C109.146 95.0271 116.74 132.279 110.323 146.503H80.4561C89.1621 130.358 103.263 89.9261 90.0205 57.3585Z"
          fill="white"
          fillOpacity="0.13"
        />
        <path
          d="M78.5642 57.1134C67.5283 6.71697 86.0438 -17.112 95.9759 -26.2676V-15.9676C87.7604 -8.32431 73.978 16.3794 84.5723 54.048C95.1666 91.7166 84.9812 129.581 78.5642 143.805L55.7568 146.503C64.4629 130.358 86.0848 91.4568 78.5642 57.1134Z"
          fill="white"
          fillOpacity="0.13"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M105.966 60.225C105.972 60.2495 105.978 60.2741 105.984 60.299C106.333 61.8411 106.287 62.8178 106.243 63.7345C106.216 64.3121 106.19 64.866 106.264 65.5224C106.327 66.0779 106.773 66.5218 107.297 67.0444C107.952 67.6969 108.73 68.4721 109.041 69.7405C109.264 70.6474 109.038 71.2959 108.81 71.9542C108.604 72.5447 108.396 73.1432 108.507 73.9433C108.557 74.3109 108.779 74.6834 109.048 75.1346C109.654 76.1535 110.5 77.5741 110.152 80.2479C110.057 80.9836 109.918 81.6008 109.743 82.1238C110.587 85.6684 111.291 89.1244 111.586 91.5999C111.618 91.7402 111.646 91.8744 111.67 92.0017C111.82 92.9042 110.997 96.0414 109.886 99.6393C110.101 103.19 110.934 106.495 111.82 110.012C112.266 111.784 112.726 113.611 113.128 115.549C112.515 115.737 111.856 115.897 111.161 116.033C111.67 127.742 109.048 142.654 109.048 142.654H103.083C100.265 143.061 96.7126 143.273 94.9814 142.171L81.7508 139.758L78.4399 93.5311C71.4506 93.8989 65.7595 91.8279 62.3768 89.9751L62.4994 87.5227C62.4994 87.5227 58.6982 84.0894 68.1399 84.0894L71.7397 83.7298H71.7403H71.7409H71.7415H71.7419H71.7425H71.7431H71.7437H71.7443H71.7449H71.7455H71.7461H71.7467H71.7473H71.7479H71.7485H71.7491H71.7497H71.7504H71.751H71.7516H71.7524H71.753H71.7537H71.7543C72.3426 83.7282 72.952 83.7265 73.5919 83.7292C73.7445 82.8334 74.0372 81.721 74.4416 80.4798L79.7034 67.0444L81.3523 59.5235C80.3289 55.8157 81.1894 50.4741 83.7858 47.6784C87.4425 42.9217 95.2151 43.7605 97.6694 48.317C98.8948 50.5931 100.526 52.3638 102.023 53.9878C103.93 56.0573 105.618 57.8888 105.966 60.225Z"
        fill="#005171"
        fillOpacity="0.13"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M57.9315 87.7049C55.7666 86.8539 52.9997 83.9601 51.835 82.8393L54.2579 80.2275C55.226 81.4709 57.8627 82.7363 60.2782 83.293L57.9315 87.7049Z"
        fill="#F2A42C"
      />
      <path d="M54.8975 85.6841L57.1046 82.7412L55.3879 86.1745L54.8975 85.6841Z" fill="#1A1A1A" fillOpacity="0.23" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M105.249 113.838C99.5678 114.552 91.8326 114.586 77.1797 111.454C78.4796 87.3253 79.8343 68.5474 80.5936 66.1784C81.2423 65.737 84.5253 62.9538 85.8768 62.7232C93.4797 61.6589 97.9689 61.9113 103.08 66.1784C104.299 68.7927 106.702 98.1305 105.717 111.454"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M96.2197 48.2539C97.5809 50.8697 99.6724 53.5932 100.866 55.5415C101.508 56.5881 104.188 57.3517 104.757 59.868C105.326 62.3818 104.845 63.3932 105.038 65.0914C105.179 66.3404 107.255 67.0253 107.814 69.3095C108.237 71.03 107.046 71.8203 107.28 73.5123C107.444 74.7101 109.427 75.9589 108.925 79.8169C108.424 83.6724 106.747 84.2754 104.758 85.1065C104.58 75.0126 102.32 66.4304 99.8487 63.6124C98.6546 62.4875 97.4445 61.7967 96.2197 61.5477C95.9402 60.6523 95.6284 60.0845 95.7547 59.2504C95.8805 58.4186 94.004 49.847 94.004 49.847L96.2197 48.2539Z"
        fill="#005171"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M85.8566 62.5638C85.4691 62.6582 85.1547 62.7614 84.9623 62.8594C84.2778 64.3558 81.6644 73.1573 78.7687 85.835C78.4412 86.2132 78.0838 86.5929 77.7023 86.9671C76.1098 85.4306 71.9089 85.9315 72.3606 83.323C73.372 77.3111 80.7594 61.4207 85.8542 62.5635"
        fill="#00AFA8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M47.2497 73.6627C45.5505 74.9 46.1099 78.1302 47.4352 80.3134C48.7605 82.4966 52.2398 83.8975 54.3968 81.7946C57.4034 79.1742 48.949 72.4253 47.2468 73.6627"
        fill="#F2A42C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M79.5754 83.5854C80.9171 86.0745 81.5412 88.6814 80.4035 90.8273C77.3908 96.2838 59.89 89.297 55.0098 86.6239L55.2653 86.1457L57.2262 82.4597L57.6047 81.7461C66.4067 84.2304 69.1269 82.7687 79.5729 83.5829"
        fill="#00AFA8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M87.7141 111.288C88.4095 121.828 99.1675 138.522 90.6407 140.952C85.4804 142.423 80.8388 138.5 80.8388 138.5C80.1016 128.445 78.3814 125.257 77.4131 110.307C77.4254 110.059 77.4401 109.814 77.4524 109.566C81.131 110.354 84.5564 110.908 87.7141 111.288Z"
        fill="#008E7D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M93.3714 141.444C91.8454 135.347 88.4103 121.829 87.7148 111.289C97.1312 112.422 101.773 112.55 106.027 112.015C107.624 122.07 105.589 127.024 105.904 141.444C105.904 141.444 96.0425 143.935 93.3714 141.444Z"
        fill="#00AFA8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M85.9595 79.5775L87.1317 65.0103L88.7057 64.6846L88.5831 69.3441L88.0179 80.8698L86.8664 110.299L88.7057 111.402C88.7057 111.402 88.0524 111.344 87.0714 111.221V113.518C86.6791 113.715 85.2794 113.446 84.9524 113.364L85.7926 111.083C85.6148 111.059 85.4376 111.034 85.263 111.01C83.3664 110.74 81.2705 104.261 81.2705 104.261L81.631 96.7736L85.9595 79.5775Z"
        fill="black"
        fillOpacity="0.23"
      />
      <mask id="mask1_8284_55483" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="90" y="63" width="22" height="54">
        <path
          d="M90.3949 64.9286C90.6086 77.242 89.6208 101.972 91.3778 114.957C95.8771 116.22 106.036 116.912 111.901 115.117C110.496 108.331 108.375 102.926 108.626 96.3853C108.626 96.3853 103.645 66.9837 95.5527 63.2119C92.604 64.6833 90.3924 64.9286 90.3924 64.9286H90.3949Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_8284_55483)">
        <path
          d="M78.4756 140.827L71.5977 61.3797L99.4855 53.8926C99.4855 53.8926 107.533 93.6555 109.315 110.052C111.526 130.407 113.492 142.914 113.492 142.914L78.4756 140.827Z"
          fill="#07D3C4"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M94.7535 63.317C96.6053 63.5365 98.6851 65.1009 99.2428 68.8196C99.7946 72.499 98.8705 78.3161 94.8077 87.1988C95.0737 87.4237 95.2425 87.7595 95.2425 88.1346C95.2425 88.1718 95.2408 88.2086 95.2375 88.245C95.2416 88.2894 95.2437 88.3345 95.2437 88.3801C95.2437 89.1927 94.5836 89.8515 93.7693 89.8515C92.955 89.8515 92.2949 89.1927 92.2949 88.3801C92.2949 87.5674 92.955 86.9086 93.7693 86.9086C93.812 86.9086 93.8543 86.9104 93.8961 86.914C93.9349 86.9103 93.9741 86.9084 94.0138 86.9084C94.0527 86.9084 94.0911 86.9102 94.1291 86.9138C98.1781 78.0672 99.036 72.4014 98.5153 68.9287C97.997 65.4732 96.1286 64.2209 94.6669 64.0476C94.4652 64.0237 94.321 63.8408 94.3449 63.6391C94.3688 63.4373 94.5517 63.2931 94.7535 63.317Z"
          fill="black"
          fillOpacity="0.23"
        />
        <path
          d="M93.2791 88.9634C94.0933 88.9634 94.7534 88.3046 94.7534 87.4919C94.7534 86.6793 94.0933 86.0205 93.2791 86.0205C92.4648 86.0205 91.8047 86.6793 91.8047 87.4919C91.8047 88.3046 92.4648 88.9634 93.2791 88.9634Z"
          fill="#5F7075"
        />
        <path
          d="M93.5236 88.4729C94.2021 88.4729 94.7522 87.9239 94.7522 87.2467C94.7522 86.5695 94.2021 86.0205 93.5236 86.0205C92.845 86.0205 92.2949 86.5695 92.2949 87.2467C92.2949 87.9239 92.845 88.4729 93.5236 88.4729Z"
          fill="#C2E1EB"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M88.4609 64.4386C88.4609 70.5646 86.9157 110.848 85.977 114.239C82.6941 114.941 75.9365 110.968 75.9365 110.968C76.0496 104.312 76.4624 106.652 78.6002 87.9817C79.9051 76.5781 81.7112 67.0433 82.2395 64.353C82.3329 63.8772 82.6548 63.4799 83.0995 63.2862L85.1399 62.2314C85.1399 62.2314 85.2838 63.391 86.4109 63.9491C86.8738 64.1783 88.4609 64.4386 88.4609 64.4386Z"
        fill="#07D3C4"
      />
      <path
        d="M106.485 116.063C106.853 121.459 106.403 125.137 106.24 127.958C106.24 127.958 106.117 117.535 105.627 116.922C105.136 116.309 104.155 116.186 104.155 116.186L106.485 116.063Z"
        fill="black"
        fillOpacity="0.23"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M100.468 65.3646C99.2094 65.6515 96.6907 67.3633 96.4744 70.9119C96.2582 74.458 99.7671 87.7896 100.467 90.7128C102.345 93.9794 104.763 96.7576 105.731 96.8949C107.321 97.7876 109.449 93.8809 110.432 91.8356C109.766 84.8243 105.019 67.7974 103.938 66.5246C102.856 65.2519 101.246 65.0654 100.468 65.3671"
        fill="#00AFA8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M94.0708 60.0625C94.6966 61.1662 95.3972 62.3333 95.2061 63.3338C95.1829 63.4543 95.1572 63.5745 95.1295 63.6918C95.6527 65.0628 95.7274 66.7209 95.5217 68.3591L99.7442 68.8839L99.7431 68.8911C99.5119 67.1995 103.285 54.5719 104.797 61.0003C105.045 56.0773 99.4884 53.5429 96.4428 47.8854C93.9885 43.3289 86.216 42.4901 82.5592 47.2468C77.8905 52.2739 78.8343 65.5331 86.2528 62.7225C86.2528 62.1556 86.098 61.2475 86.1302 60.3928C86.1607 59.5838 86.375 58.8279 86.4906 58.2752C86.4906 57.5725 84.5925 56.1365 84.412 53.076C84.1776 49.1393 85.8468 47.5183 86.216 47.2466C91.9257 44.8729 93.3679 51.7496 93.3591 53.8936C93.51 54.3082 93.449 55.5987 93.2523 57.2927C93.5016 57.0575 93.7149 56.8466 93.8785 56.6852C94.0743 57.8383 94.1413 58.9396 94.0732 60.0628"
        fill="#005171"
      />
      <path d="M83.3442 110.699L84.693 99.1725L78.6846 98.8047C77.8018 101.944 77.5811 107.061 77.5811 109.227L83.3442 110.699Z" fill="#32DDD0" />
      <path d="M100.143 112.415L100.879 100.521L93.0312 100.184C93.0312 103.046 93.3991 109.227 93.7669 111.765L100.143 112.415Z" fill="#32DDD0" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M98.6381 116.307L101.581 111.893L107.957 99.7539L108.325 102.697L104.279 113.61L103.298 113.242L102.657 116.213H103.192C103.154 117.098 102.635 120.244 100.968 121.703C99.0059 123.419 95.9404 121.703 95.9404 121.703L100.42 116.307H98.6381Z"
        fill="black"
        fillOpacity="0.12"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M99.145 110.299L98.1859 113.35C96.542 114.409 93.6202 115.628 93.173 116.462C90.035 122.316 98.1073 123.642 99.8937 121.082C100.864 119.692 101.81 116.879 101.68 114.718L103.322 112.015L99.145 110.299Z"
        fill="#F2A42C"
      />
      <path d="M103.087 112.415L99.1631 110.331V110.208L103.455 111.802L103.087 112.415Z" fill="#1A1A1A" fillOpacity="0.23" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M101.002 85.8064C99.7468 91.5057 98.8122 104.821 98.79 110.15L104.103 112.338C105.356 109.351 110.812 93.7767 110.444 91.5695C109.831 88.2588 106.295 80.2972 104.516 79.8926C103.547 80.0373 101.206 84.6023 101.002 85.8064Z"
        fill="#00AFA8"
      />
      <path
        d="M76.4441 90.1886C77.4251 89.1096 79.387 79.6025 80.6132 72.7767L80.8584 72.041C80.8584 72.041 79.9377 77.7295 79.387 81.7279C78.8363 85.7264 78.0382 92.5184 78.0382 92.5184C74.8501 93.3767 70.2723 92.2323 67.9834 91.6601C70.3949 91.6192 75.4632 91.2677 76.4441 90.1886Z"
        fill="black"
        fillOpacity="0.23"
      />
      <path d="M90.3123 61.0194C87.0724 60.4719 80.966 61.9108 82.4595 72.0461" stroke="#A5C8D3" strokeLinecap="round" />
      <path d="M94.2206 62.7933C97.5341 63.1859 101.821 69.3313 93.6451 87.1538" stroke="#A5C8D3" strokeLinecap="round" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M84.8916 62.8968C86.7457 61.241 89.2086 61.0154 90.8993 61.3011C91.0996 61.3349 91.2345 61.5248 91.2007 61.7251C91.1668 61.9254 90.977 62.0604 90.7767 62.0265C89.2275 61.7647 87.0172 61.9849 85.3816 63.4455C84.1521 64.5435 83.1934 66.392 83.1254 69.406C83.2005 69.4923 83.2458 69.605 83.2456 69.7284C83.2444 70.5403 83.3063 71.4349 83.443 72.4193C84.4839 72.281 85.3381 72.555 85.9999 73.1452C86.7142 73.7821 87.1516 74.7405 87.4166 75.7707C87.9363 77.7908 87.8516 80.3214 87.6178 82.0695C87.7826 82.2449 87.8835 82.481 87.8835 82.7407C87.8835 83.2825 87.4443 83.7217 86.9025 83.7217C86.3608 83.7217 85.9216 83.2825 85.9216 82.7407C85.9216 82.2809 86.238 81.8949 86.665 81.7887C86.8749 80.1114 86.9278 77.8079 86.4666 76.0151C86.2236 75.0705 85.8531 74.3286 85.347 73.8773C84.8673 73.4495 84.2163 73.2378 83.2729 73.4448C82.3444 73.6484 81.7808 74.1532 81.4467 74.8467C81.1004 75.5656 80.9886 76.5167 81.0583 77.5968C81.1746 79.3999 81.7866 81.4239 82.4222 82.9876C82.4441 82.9861 82.4662 82.9854 82.4885 82.9854C83.0302 82.9854 83.4694 83.4245 83.4694 83.9663C83.4694 84.5081 83.0302 84.9473 82.4885 84.9473C81.9467 84.9473 81.5075 84.5081 81.5075 83.9663C81.5075 83.8206 81.5393 83.6823 81.5963 83.558C80.9066 81.9069 80.2097 79.6805 80.0794 77.66C80.0044 76.4981 80.1131 75.3546 80.563 74.4209C80.9484 73.6209 81.5748 72.9972 82.4857 72.6558C82.3335 71.5919 82.2633 70.6179 82.2647 69.7269C82.2649 69.6011 82.3123 69.4865 82.3903 69.3998C82.4601 66.2274 83.4696 64.1666 84.8916 62.8968Z"
        fill="black"
        fillOpacity="0.12"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M86.0091 60.5149C82.8957 59.3672 84.3512 50.4481 84.6264 48.3047C86.9215 49.7099 90.2167 50.1513 92.4602 50.3058L92.1383 52.7435L93.6127 53.2144L93.4407 56.3411C93.8658 55.3062 95.1289 54.3277 95.7555 54.9384C96.677 55.8335 95.3648 57.9499 93.856 58.3398L93.8634 59.7058L93.856 62.3861C93.4653 63.9262 87.3926 64.348 86.1664 63.1218L86.0091 60.5149Z"
        fill="#F2A42C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M85.5777 60.2053C85.7066 60.2944 85.8453 60.3672 85.9945 60.4222L86.1191 62.4879C89.2416 61.9529 91.0556 59.1085 91.4246 57.9707C90.5708 58.1053 85.5039 59.3195 85.5039 59.3195L85.5777 60.2053Z"
        fill="#1A1A1A"
        fillOpacity="0.23"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M87.4055 60.6888C89.2576 60.6065 90.897 59.3036 91.8307 58.3869C93.8881 55.2087 94.4196 48.9094 90.3577 46.964C88.9453 46.288 86.3475 45.9019 84.2707 47.1496C83.8718 47.4429 82.0682 49.1922 82.3222 53.4415C82.5763 57.6909 84.1733 60.6434 87.1583 60.6891C87.2413 60.6908 87.3247 60.69 87.4059 60.6862"
        fill="#F2A42C"
      />
      <path
        d="M83.3592 48.6205C84.6344 46.2662 86.9969 46.3723 88.3866 46.4132V44.8193L84.2175 46.0455L80.7842 50.4598L82.0104 53.4027C82.0104 52.9122 82.0839 50.9748 83.3592 48.6205Z"
        fill="#005171"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M88.3361 46.4178C89.1108 46.3238 90.6951 47.0116 90.7934 48.4972C90.8765 49.7548 89.6351 52.8953 89.9333 54.7508C90.4455 57.9356 92.7214 58.286 92.4766 61.0046C92.3396 62.5341 91.2718 63.6596 91.0488 65.2158C90.7628 67.204 92.9325 68.1452 92.7592 70.0784C92.6123 71.7229 91.413 71.0967 91.0488 75.2284C90.8278 77.7398 91.4091 81.7427 93.3406 83.3161C93.3406 83.3161 94.1107 84.4196 96.6909 84.4196C99.2711 84.4196 101.717 82.8305 102.466 80.501C103.448 77.444 100.392 70.0784 100.254 68.9748C100.131 67.9941 99.3939 64.5348 102.588 65.5417C105.783 66.5487 98.4749 59.8419 98.4749 59.8419C98.4749 59.8419 97.7094 50.711 92.4766 46.4179C91.8044 45.8677 89.1416 45.4317 89.1416 45.4317L88.5444 46.4298L88.3361 46.4178Z"
        fill="#005171"
      />
      <path
        d="M139 42C139 42.5523 138.552 43 138 43C137.448 43 137 42.5523 137 42C137 41.4477 137.448 41 138 41C138.552 41 139 41.4477 139 42Z"
        fill="#FF9800"
      />
      <path
        d="M170 79C170 79.5523 169.552 80 169 80C168.448 80 168 79.5523 168 79C168 78.4477 168.448 78 169 78C169.552 78 170 78.4477 170 79Z"
        fill="#FF9800"
      />
      <path
        d="M40 22.5C40 23.3284 39.5523 24 39 24C38.4477 24 38 23.3284 38 22.5C38 21.6716 38.4477 21 39 21C39.5523 21 40 21.6716 40 22.5Z"
        fill="#FF9800"
      />
      <path
        d="M25 88.5C25 89.3284 24.3284 90 23.5 90C22.6716 90 22 89.3284 22 88.5C22 87.6716 22.6716 87 23.5 87C24.3284 87 25 87.6716 25 88.5Z"
        fill="#FF9800"
      />
      <path
        d="M146 121C146 122.657 144.881 124 143.5 124C142.119 124 141 122.657 141 121C141 119.343 142.119 118 143.5 118C144.881 118 146 119.343 146 121Z"
        fill="#FF9800"
      />
      <g filter="url(#filter0_dd_8284_55483)">
        <path
          d="M44.9947 114.747C44.9947 118.203 42.188 121.004 38.7258 121.004C35.2637 121.004 32.457 118.203 32.457 114.747C32.457 111.292 35.2637 108.491 38.7258 108.491C42.188 108.491 44.9947 111.292 44.9947 114.747Z"
          fill="white"
        />
      </g>
      <path
        d="M40.8213 114.193V112.898C40.8213 112.676 40.6307 112.528 40.4401 112.528H35.8656C35.675 112.528 35.4844 112.676 35.4844 112.898V116.598C35.4844 116.783 35.675 116.968 35.8656 116.968H40.4401C40.6307 116.968 40.8213 116.783 40.8213 116.598V115.303L42.3461 116.783V112.713L40.8213 114.193Z"
        fill="currentColor"
      />
      <g filter="url(#filter1_dd_8284_55483)">
        <path
          d="M156.333 92.0584C156.333 96.2571 152.922 99.6608 148.715 99.6608C144.508 99.6608 141.098 96.2571 141.098 92.0584C141.098 87.8598 144.508 84.4561 148.715 84.4561C152.922 84.4561 156.333 87.8598 156.333 92.0584Z"
          fill="white"
        />
      </g>
      <path
        d="M152.065 94.3098L150.74 93.0311V92.2852C150.741 92.1473 150.703 92.0118 150.63 91.893L149.668 90.333C149.641 90.2883 149.627 90.2373 149.626 90.1854V89.8364C149.731 89.791 149.821 89.7173 149.884 89.6242C149.947 89.531 149.98 89.4223 149.981 89.3111V88.7138C149.981 88.561 149.918 88.4144 149.806 88.3061C149.694 88.1978 149.543 88.1366 149.385 88.1357H146.877C146.718 88.136 146.566 88.197 146.454 88.3054C146.342 88.4138 146.279 88.5606 146.279 88.7138V89.3111C146.279 89.4223 146.313 89.5309 146.376 89.6241C146.439 89.7172 146.528 89.7909 146.633 89.8364V90.1854C146.633 90.2023 146.631 90.219 146.627 90.2355V90.2408C146.621 90.2732 146.609 90.3044 146.592 90.333L145.632 91.8877C145.559 92.0066 145.521 92.1423 145.521 92.2804V95.5784C145.522 95.7382 145.588 95.8913 145.705 96.0042C145.822 96.1172 145.981 96.1807 146.146 96.181H150.114C150.201 96.1808 150.288 96.1628 150.368 96.1282C150.448 96.0936 150.519 96.0432 150.578 95.9801C150.81 96.146 151.099 96.2209 151.386 96.1897C151.673 96.1585 151.937 96.0236 152.126 95.812C152.314 95.6004 152.412 95.3279 152.401 95.0492C152.39 94.7704 152.27 94.5061 152.065 94.3093V94.3098ZM146.018 95.2886V92.3267L146.042 92.2836L150.242 92.3049V92.656C149.997 92.5527 149.723 92.535 149.467 92.6059C149.211 92.6769 148.988 92.8321 148.837 93.0446C148.687 93.2572 148.618 93.5139 148.643 93.7703C148.667 94.0266 148.784 94.2667 148.972 94.4489L149.842 95.2886H146.018ZM150.907 93.8698C150.904 93.8717 150.901 93.8738 150.898 93.8761L149.978 94.6892C149.969 94.6978 149.96 94.7076 149.954 94.7185L149.881 94.6524L149.322 94.1095C149.206 93.991 149.142 93.8337 149.145 93.6708C149.147 93.5079 149.215 93.3524 149.335 93.2372C149.454 93.122 149.615 93.0562 149.784 93.0539C149.953 93.0515 150.116 93.1128 150.238 93.2245L150.907 93.8698ZM151.714 95.5342C151.592 95.6514 151.427 95.7172 151.255 95.7172C151.083 95.7172 150.919 95.6514 150.797 95.5342L150.234 94.9913L150.153 94.9124C150.16 94.9081 150.167 94.9033 150.174 94.8981L151.095 94.0829C151.101 94.0775 151.107 94.0716 151.111 94.0653L151.718 94.6514C151.84 94.7687 151.908 94.9279 151.908 95.0938C151.908 95.2598 151.84 95.4189 151.718 95.5363L151.714 95.5342Z"
        fill="currentColor"
      />
      <path
        d="M147.598 92.9121H147.033V93.5256H146.418V94.0899H147.033V94.7034H147.598V94.0899H148.213V93.5256H147.598V92.9121Z"
        fill="currentColor"
      />
      <g filter="url(#filter2_dd_8284_55483)">
        <path
          d="M45.5061 50.124C44.4694 50.124 43.519 50.4519 42.6813 51.0985C41.8781 51.7184 41.3434 52.5079 41.0286 53.0821C40.7138 52.5079 40.1791 51.7184 39.3759 51.0985C38.5382 50.4519 37.5877 50.124 36.5511 50.124C33.6582 50.124 31.4766 52.4855 31.4766 55.6171C31.4766 59.0004 34.1983 61.3151 38.3185 64.8193C39.0182 65.4144 39.8113 66.0889 40.6356 66.8083C40.7443 66.9033 40.8838 66.9556 41.0286 66.9556C41.1734 66.9556 41.3129 66.9033 41.4216 66.8084C42.2459 66.0889 43.039 65.4144 43.7391 64.8189C47.8589 61.3151 50.5806 59.0004 50.5806 55.6171C50.5806 52.4855 48.399 50.124 45.5061 50.124Z"
          fill="white"
        />
      </g>
      <g filter="url(#filter3_dd_8284_55483)">
        <path
          d="M168.357 53.6811C168.357 59.031 164.011 63.368 158.651 63.368C153.29 63.368 148.944 59.031 148.944 53.6811C148.944 48.3311 153.29 43.9941 158.651 43.9941C164.011 43.9941 168.357 48.3311 168.357 53.6811Z"
          fill="white"
        />
      </g>
      <path
        d="M164.312 54.1302C164.312 53.1741 163.522 52.3964 162.551 52.3964C161.579 52.3964 160.789 53.1741 160.789 54.1302C160.789 54.9178 161.323 55.5815 162.053 55.7896C162.048 55.8144 162.048 55.8391 162.048 55.8639C162.048 57.2311 160.92 58.3407 159.531 58.3407C158.142 58.3407 157.015 57.2311 157.015 55.8639C157.015 55.849 157.015 55.8391 157.01 55.8243C157.744 55.7252 158.424 55.4032 158.962 54.8831C159.657 54.2243 160.034 53.3425 160.034 52.3964V49.9197C160.034 49.3748 159.581 48.9289 159.028 48.9289H158.524C158.524 48.6565 158.298 48.4336 158.021 48.4336C157.744 48.4336 157.518 48.6565 157.518 48.9289V49.9197C157.518 50.1921 157.744 50.415 158.021 50.415C158.298 50.415 158.524 50.1921 158.524 49.9197H159.028V52.3964C159.028 53.0701 158.756 53.7042 158.263 54.1747C157.77 54.6453 157.12 54.888 156.436 54.8732C155.087 54.8336 153.995 53.6645 153.995 52.2726V49.9197H154.498C154.498 50.1921 154.725 50.415 155.001 50.415C155.278 50.415 155.505 50.1921 155.505 49.9197V48.9289C155.505 48.6565 155.278 48.4336 155.001 48.4336C154.725 48.4336 154.498 48.6565 154.498 48.9289H153.995C153.441 48.9289 152.988 49.3748 152.988 49.9197V52.2726C152.988 54.0608 154.307 55.5766 156.013 55.8243C156.008 55.8391 156.008 55.849 156.008 55.8639C156.008 57.776 157.588 59.3314 159.531 59.3314C161.474 59.3314 163.054 57.776 163.054 55.8639C163.054 55.8391 163.054 55.8144 163.049 55.7896C163.779 55.5815 164.312 54.9178 164.312 54.1302ZM162.551 54.8732C162.133 54.8732 161.796 54.5413 161.796 54.1302C161.796 53.719 162.133 53.3871 162.551 53.3871C162.969 53.3871 163.306 53.719 163.306 54.1302C163.306 54.5413 162.969 54.8732 162.551 54.8732Z"
        fill="currentColor"
      />
      <path d="M110.5 138C110.5 138 77.2946 134 77 134L73 146.561L118 151L110.5 138Z" fill="white" />
      <path
        d="M96 145C96 147.761 93.9853 150 91.5 150C89.0147 150 87 147.761 87 145C87 142.239 89.0147 140 91.5 140C93.9853 140 96 142.239 96 145Z"
        fill="#F4F4F4"
      />
      <circle cx="86.4087" cy="82.0054" r="0.980953" fill="#7C97A0" />
      <path
        d="M86.588 81.4677C87.07 78.0241 86.955 71.3738 82.639 72.3206C78.3229 73.2673 80.2964 80.1101 81.8226 83.4132"
        stroke="#456069"
        strokeLinecap="round"
      />
      <path d="M82.4578 72.0456C82.298 70.9613 82.2252 69.9765 82.2266 69.083" stroke="#456169" strokeLinecap="round" />
      <circle cx="81.9946" cy="83.4761" r="0.980953" fill="#7C97A0" />
      <defs>
        <filter
          id="filter0_dd_8284_55483"
          x="29.457"
          y="106.491"
          width="18.5381"
          height="18.5127"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_8284_55483" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="effect1_dropShadow_8284_55483" result="effect2_dropShadow_8284_55483" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8284_55483" result="shape" />
        </filter>
        <filter
          id="filter1_dd_8284_55483"
          x="138.098"
          y="82.4561"
          width="21.2354"
          height="21.2051"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_8284_55483" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="effect1_dropShadow_8284_55483" result="effect2_dropShadow_8284_55483" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8284_55483" result="shape" />
        </filter>
        <filter
          id="filter2_dd_8284_55483"
          x="28.4766"
          y="48.124"
          width="25.1045"
          height="22.832"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_8284_55483" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="effect1_dropShadow_8284_55483" result="effect2_dropShadow_8284_55483" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8284_55483" result="shape" />
        </filter>
        <filter
          id="filter3_dd_8284_55483"
          x="145.944"
          y="41.9941"
          width="25.4131"
          height="25.374"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_8284_55483" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="effect1_dropShadow_8284_55483" result="effect2_dropShadow_8284_55483" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8284_55483" result="shape" />
        </filter>
        <linearGradient id="paint0_linear_8284_55483" x1="93.6165" y1="-161.026" x2="93.6165" y2="127.497" gradientUnits="userSpaceOnUse">
          <stop stopColor="#004F70" />
          <stop offset="0.875" stopColor="currentColor" />
        </linearGradient>
      </defs>
    </svg>
  )
}
